import React from 'react'

const Loading = () => {
  return <div className="lds-roller mb-5">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
};

export default Loading;